// import { useRef, useState, useEffect } from "react";
import { useSelector } from "react-redux"
import { Box } from "@mui/material";
import Typography from '@mui/material/Typography';
// import Backdrop from '@mui/material/Backdrop';
// import Modal from '@mui/material/Modal';
// import Fade from '@mui/material/Fade';
// import Button from '@mui/material/Button';
// import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
// import MenuItem from '@mui/material/MenuItem';
// import Switch from '@mui/material/Switch';
// import { selectCurrentUser, selectSelectedReportDetails } from "../auth/authSlice"
import { selectUserData } from "../data/dataSlice"

const style = {
    width: 500,
    p: 2,
  };

  // const currencies = [
  //   {
  //     value: 'Daily',
  //     label: 'Daily',
  //   },
  //   {
  //     value: 'Weekly',
  //     label: 'Weekly',
  //   },
  //   {
  //     value: 'By Weekly',
  //     label: 'By Weekly',
  //   },
  //   {
  //     value: 'Monthly',
  //     label: 'Monthly',
  //   },
  // ];
  // const label = { inputProps: { 'aria-label': 'Switch demo' } };
const UserProfile = ({ openAddSubscription, handleAddSubscriptionClose }) => {
    // const user = useSelector(selectCurrentUser)
    const userdata = useSelector(selectUserData)
    // const reportEmbeddObj = useSelector(selectSelectedReportDetails)

  return (
<Box sx={style}>
            <Typography id="transition-modal-title" variant="h3" component="h2">
              User Profile
            </Typography>
            {/* <div className="divdivider">{ reportEmbeddObj && reportEmbeddObj.name && (<Typography variant="h6" component="h6">
            </Typography>)}
        </div> */}
        {/* <div className="switchdiv">
            <Stack direction="row" spacing={1} alignItems="center">
                <Typography>Off</Typography>
                <Switch {...label} color="secondary" defaultChecked />
                <Typography>On</Typography>
            </Stack>
        </div> */}
            <TextField fullWidth id="loginid" label="User ID" variant="filled" value={userdata.userName} disabled className="loginiddisplay" />
            <TextField fullWidth className="subscriptionformfeild" id="language" label="Language" value={userdata.language && userdata.language.language ? userdata.language.language : "English US"} variant="filled" disabled />
            <TextField fullWidth className="subscriptionformfeild" id="timezone" label="Timezone" value={userdata.timeZone ? userdata.timeZone : "GST"} variant="filled" disabled />
            <TextField fullWidth className="subscriptionformfeild" id="createdon" label="Created On" value={userdata.created} variant="filled" disabled />
            <TextField fullWidth className="subscriptionformfeild" id="lastLogin" label="Last Login On" value={userdata.lastLogin} variant="filled" disabled />
            {/* <Stack className="divlogoutbtn" direction="row" spacing={2}>
              <Button variant="contained" color="primary">Subscribe</Button>
              <Button variant="outlined" color="primary" onClick={handleAddSubscriptionClose}>Cancel</Button>
            </Stack> */}
          </Box>
  );
};

export default UserProfile;
